// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // domain: 'http://localhost:3000/',
  domain: 'https://erp.fsc.gov.vn/',
  // domain: 'https://fscerp-dev.chips.com.vn/',
  NEXT_PUBLIC_PUBLIC_KEY_RSA_Server_Receive: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArzYyZ2ZEn5arhMl6WX+T
AHmBFxgrN7IsQSe+6ID521uFZ+MftVt+gQcK1sKN4Z7bjJCtp3w8BNE8LMQRRG4B
Gv9SaHaqsRQV3atMj91t3OMBYewkAcY0CyzbBKnX2RyiSEgFmMdEsU7HrEg2AJ8G
e8YyTAJ6v7iEeF9mqF8eqS4ySx/+TEHLb+/4m7LeSxhfMr698EpyrFIEeep2h/Gh
/b5VSYA+NUXMQPHYmgoWsE+TKtq1vsTevYuPzgtW/PBRdXJ5o59jpqpbPsZM5cBD
YKTMkjtUdfD5if5S6WUPftuEH1PAhiP0QtR3SHissQfcE616ODwX+mrdjGAVGrEs
wQIDAQAB
-----END PUBLIC KEY-----`,
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
